import { Card } from "@/components/ui/card";
import { FormikCheckbox } from "@/features/forms/components/formik-controls";

/**
 * Part VII — Refund election (legacy `sr_part7.php`). A single checkbox; the
 * terminal step — Print/Archive on the sticky action bar are the final actions.
 */
export function SrPart7() {
  return (
    <Card className="flex flex-col gap-3 p-6">
      <span className="text-foreground text-sm">
        <span className="text-muted-foreground mr-2 font-mono">25</span>
        Refund election
      </span>
      <FormikCheckbox
        name="check_box_refund"
        label="By checking this box and signing this form, I would like a refund if I qualify for relief and already paid the tax."
      />
      <p className="text-muted-foreground text-xs">
        Use the action bar below to Print (preview) or Archive (save the completed
        Form 8857 to the client's Documents).
      </p>
    </Card>
  );
}
